import Model from "./base/model";

class TakerFinalBeneficiary extends Model{
  resourceName() {
    return "taker_final_beneficiaries";
  }

  fields() {
    return {
      name: "",
      type: "",
      document_number: "",
    };
  }

}

export default new TakerFinalBeneficiary();
